<div class="w-100 row-container toolbar-logos">
  <a [routerLink]="getHomeUrl()" class="toolbar-logos__desktop">
    <img *ngIf="!isVakiSite" [src]="logo?.src" [alt]="logo?.alt" />
    <img *ngIf="isVakiSite" [src]="siteLogo?.src" [alt]="siteLogo?.alt" />
  </a>

  <div *ngIf="isVakiSite" class="ml-2 toolbar-logos__vaki">
    <span ngClass="toolbar-logos__vaki__by text-white">By</span>
    <a routerLink="/" class="toolbar-logos__vaki__by__vaki ml-2">
      <img
        class="toolbar-logos__vaki__by__vaki__logo"
        [src]="LOGO_VAKI_WHITE.src"
        [alt]="LOGO_VAKI_WHITE.alt"
      />
    </a>
  </div>
</div>
